import { render, staticRenderFns } from "./CollapseItem.vue?vue&type=template&id=eb886696&scoped=true"
import script from "./CollapseItem.vue?vue&type=script&lang=js"
export * from "./CollapseItem.vue?vue&type=script&lang=js"
import style0 from "./CollapseItem.vue?vue&type=style&index=0&id=eb886696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb886696",
  null
  
)

export default component.exports